import styled from 'styled-components'
import { darken } from 'polished'
import { Spinner } from 'lib/ui/components/Spinner'
import { Button } from 'lib/ui/components/Button/index'

export const ButtonContent = styled.div`
  flex-grow: 1;
  padding: 0 2em;
  text-align: center;
`

export const LeftAdHoc = styled.div`
  padding: 0 2em;
  border-radius: 25px 0 0 25px;
  background: ${props => props.theme.palette.primary.alphaDark};
  transition: background 300ms ease;
`

export const StyledButton = styled.button<any>`
  ${props => props.theme.css.buttonPrimary}
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0;
  ${props => props.isLoading && `
    cursor: wait !important;
  `}

  ${Spinner} {
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    right: 13px;
  }

  ${ButtonContent} {
    ${props => props.hasLeftAdHoc && `
      padding: 0 4em 0 2em;
    `}
  }

  &:hover,
  &:focus {
    ${LeftAdHoc} {
      background: ${props => darken(0.1, props.theme.palette.primary.alphaDark)};
    }
  }

  ${props => props.skin === Button.SKIN.OUTLINE && `
    color: ${props.theme.palette.primary.alpha} !important;
    line-height: 48px;
    border: 1px solid ${props.theme.palette.primary.alpha};
    background-color: ${props.theme.palette.general.light};
    transition: border-color 200ms ease;

    &:hover,
    &:focus {
      border: 1px solid ${props.theme.palette.primary.alpha};
      background-color: ${props.theme.palette.general.light};
    }
  `}

  ${props => props.skin === Button.SKIN.TEXT && `
    color: ${props.theme.palette.general.strong} !important;
    min-width: unset;
    border-radius: 0;
    background-color: transparent;

    &:hover,
    &:focus {
      background-color: transparent;
    }
  `}
`
